import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import '../styles/ThemeToggle.css';

// Mirrors the mgv.gallery navbar theme toggle so the Language Center navbar
// matches. Relies on the existing ThemeContext (light/dark + localStorage).
const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const isDark = theme === 'dark';

  return (
    <div className="theme-toggle-container">
      <label className="theme-toggle-label" htmlFor="lc-theme-toggle">
        <input
          type="checkbox"
          id="lc-theme-toggle"
          className="theme-toggle-input"
          checked={isDark}
          onChange={toggleTheme}
          aria-label={isDark ? t('theme.toLight', 'Switch to light mode') : t('theme.toDark', 'Switch to dark mode')}
        />
        <span className="theme-toggle-slider">
          <span className="theme-toggle-slider-thumb">
            {isDark ? (
              <Moon className="theme-toggle-icon" size={14} />
            ) : (
              <Sun className="theme-toggle-icon" size={14} />
            )}
          </span>
        </span>
      </label>
    </div>
  );
};

export default ThemeToggle;
